/* oh!oh! home experience — marquee countdown, hero + campaign sliders, skin quiz, ajax add-to-cart */
(() => {
  'use strict';

  /* R5-2: every oh!oh! section includes this file, and the browser runs each <script> tag,
     so without this guard the document-level click handlers register once per section
     (one add-to-cart click fired 5 requests, the + stepper jumped by 5). */
  if (window.__ohohInit) return;
  window.__ohohInit = true;

  /* ---- sticky offset: header sits below the marquee ---- */
  function syncMarqueeHeight() {
    const marquee = document.querySelector('.ohoh-marquee');
    const h = marquee ? marquee.offsetHeight : 0;
    document.documentElement.style.setProperty('--oh-marquee-h', `${h}px`);
  }
  window.addEventListener('resize', syncMarqueeHeight);
  document.addEventListener('DOMContentLoaded', syncMarqueeHeight);
  document.addEventListener('shopify:section:load', syncMarqueeHeight);

  /* ---- countdown (marquee) ---- */
  function startCountdowns() {
    document.querySelectorAll('[data-ohoh-countdown]').forEach((el) => {
      if (el.dataset.ohohCountdownInit) return;
      el.dataset.ohohCountdownInit = 'true';
      const end = new Date(el.dataset.end);
      if (isNaN(end)) return;
      const targets = el.querySelectorAll('.ohoh-marquee__cd-value');
      const dayWord = el.dataset.dayWord || 'ngày';
      const endedText = el.dataset.endedText || '';
      const pad = (n) => String(n).padStart(2, '0');
      const tick = () => {
        const ms = end - new Date();
        let text;
        if (ms <= 0) {
          text = endedText;
          clearInterval(timer);
        } else {
          const d = Math.floor(ms / 864e5);
          const h = Math.floor(ms / 36e5) % 24;
          const m = Math.floor(ms / 6e4) % 60;
          const s = Math.floor(ms / 1e3) % 60;
          text = (d ? `${d} ${dayWord} ` : '') + `${pad(h)} : ${pad(m)} : ${pad(s)}`;
        }
        targets.forEach((t) => (t.textContent = text));
      };
      const timer = setInterval(tick, 1000);
      tick();
    });
  }
  document.addEventListener('DOMContentLoaded', startCountdowns);
  document.addEventListener('shopify:section:load', startCountdowns);

  /* ---- toast ---- */
  let toastTimer;
  function showToast(msg) {
    let toast = document.querySelector('.ohoh-toast');
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'ohoh-toast';
      document.body.appendChild(toast);
    }
    toast.textContent = msg;
    toast.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => (toast.hidden = true), 2200);
  }

  /* ---- ajax add to cart (opens theme cart drawer) ---- */
  async function ohohAddToCart(items, message) {
    const drawer = document.querySelector('cart-drawer');
    const body = { items };
    if (drawer && typeof drawer.getSectionsToRender === 'function') {
      body.sections = drawer.getSectionsToRender().map((s) => s.id);
      body.sections_url = window.location.pathname;
    }
    try {
      const res = await fetch(`${window.routes.cart_add_url}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
        body: JSON.stringify(body),
      });
      const data = await res.json();
      if (data.status && data.status !== 200) {
        showToast(data.description || data.message || 'Error');
        return false;
      }
      if (drawer && data.sections) {
        drawer.renderContents(data);
      } else {
        window.location.href = window.routes.cart_url;
      }
      if (message) showToast(message);
      return true;
    } catch (e) {
      window.location.href = window.routes.cart_url;
      return false;
    }
  }

  document.addEventListener('click', (event) => {
    const btn = event.target.closest('[data-ohoh-add]');
    if (!btn) return;
    event.preventDefault();
    const id = Number(btn.dataset.ohohAdd);
    if (!id) return;
    const quantity = Math.max(1, Number(btn.dataset.ohohAddQty) || 1);
    btn.setAttribute('aria-disabled', 'true');
    ohohAddToCart([{ id, quantity }], btn.dataset.ohohAddMessage || '').finally(() =>
      btn.removeAttribute('aria-disabled')
    );
  });

  /* ---- product card variant selector ---- */
  document.addEventListener('change', (event) => {
    const select = event.target.closest('[data-ohoh-variant-select]');
    if (!select) return;
    const card = select.closest('[data-ohoh-variant-card]');
    if (!card) return;
    const option = select.selectedOptions[0];
    const available = option.dataset.available === 'true';
    const btn = card.querySelector('[data-ohoh-add]');
    if (btn) {
      btn.dataset.ohohAdd = select.value;
      btn.disabled = !available;
      const label = btn.querySelector('span');
      if (label) label.textContent = available ? btn.dataset.labelAdd : btn.dataset.labelSoldout;
    }
    const price = card.querySelector('[data-ohoh-card-price]');
    if (price && option.dataset.price) {
      if (option.dataset.compare) {
        /* R3-6: mirrors snippets/ohoh-sale-price.liquid */
        const offLabel = (select.dataset.discountLabel || '__N__% off').replace('__N__', option.dataset.discount);
        const off = option.dataset.discount ? ` <span class="ohoh-sale-price__off">${offLabel}</span>` : '';
        price.innerHTML = `<span class="ohoh-sale-price"><span class="ohoh-sale-price__now">${option.dataset.price}</span> <s class="ohoh-sale-price__was">${option.dataset.compare}</s>${off}</span>`;
      } else {
        price.textContent = option.dataset.price;
      }
    }
  });

  /* ---- hero slider + concerns ---- */
  class OhohHero extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.ohoh-hero__track');
      this.slides = Array.from(this.querySelectorAll('.ohoh-hero__slide'));
      this.dots = Array.from(this.querySelectorAll('.ohoh-hero__dots button'));
      this.index = 0;
      this.holds = new Set();
      this.dots.forEach((dot, i) => dot.addEventListener('click', () => this.go(i)));
      /* Hero arrows: prev / next */
      this.querySelector('[data-ohoh-hero-prev]')?.addEventListener('click', () => this.go(this.index - 1));
      this.querySelector('[data-ohoh-hero-next]')?.addEventListener('click', () => this.go(this.index + 1));

      this.querySelectorAll('.ohoh-concern-row').forEach((row) => {
        ['mouseenter', 'focus'].forEach((evt) =>
          row.addEventListener(evt, () => this.activateConcern(row.dataset.index))
        );
      });

      if (this.slides.length > 1) {
        this.bindDrag();
        this.bindAutoplay();
      }
    }

    disconnectedCallback() {
      this.stopAutoplay();
      this.observer?.disconnect();
      if (this.onVisibility) document.removeEventListener('visibilitychange', this.onVisibility);
    }

    go(i) {
      const n = this.slides.length;
      this.index = ((i % n) + n) % n;
      this.track.style.transform = `translateX(-${this.index * 100}%)`;
      this.dots.forEach((dot, d) => dot.setAttribute('aria-current', d === this.index ? 'true' : 'false'));
      /* a manual move restarts the clock so the new slide gets its full display time */
      if (this.timer) {
        this.stopAutoplay();
        this.startAutoplay();
      }
    }

    /* ---- drag / swipe (pointer events, works for mouse and touch) ---- */
    bindDrag() {
      const track = this.track;
      let startX = 0;
      let startY = 0;
      let startTime = 0;
      let dx = 0;
      let axis = null; /* 'x' once we own the gesture, 'y' when the browser scrolls */
      let pointerId = null;

      const onMove = (e) => {
        if (e.pointerId !== pointerId) return;
        const mx = e.clientX - startX;
        const my = e.clientY - startY;
        if (axis === null) {
          if (Math.abs(mx) < 6 && Math.abs(my) < 6) return;
          axis = Math.abs(mx) > Math.abs(my) ? 'x' : 'y';
          if (axis === 'x') track.classList.add('is-dragging');
        }
        if (axis !== 'x') return;
        dx = mx;
        track.style.transform = `translateX(calc(-${this.index * 100}% + ${dx}px))`;
      };

      const onUp = (e) => {
        if (e.pointerId !== pointerId) return;
        pointerId = null;
        window.removeEventListener('pointermove', onMove);
        window.removeEventListener('pointerup', onUp);
        window.removeEventListener('pointercancel', onUp);
        track.classList.remove('is-dragging');
        if (axis === 'x') {
          const quick = Math.abs(dx) > 30 && performance.now() - startTime < 300;
          const far = Math.abs(dx) > Math.min(80, track.offsetWidth * 0.15);
          this.go(quick || far ? this.index - Math.sign(dx) : this.index);
          /* the pointer moved, so the click that follows is not a tap on a link */
          this.dragEndedAt = performance.now();
        }
        axis = null;
        dx = 0;
        this.release('drag');
      };

      track.addEventListener('pointerdown', (e) => {
        if (e.pointerType === 'mouse' && e.button !== 0) return;
        if (pointerId !== null) return;
        pointerId = e.pointerId;
        startX = e.clientX;
        startY = e.clientY;
        startTime = performance.now();
        dx = 0;
        axis = null;
        this.dragEndedAt = 0;
        this.hold('drag');
        window.addEventListener('pointermove', onMove);
        window.addEventListener('pointerup', onUp);
        window.addEventListener('pointercancel', onUp);
      });

      /* no native image / link dragging, it would steal the pointer sequence */
      track.addEventListener('dragstart', (e) => e.preventDefault());

      /* swallow the click released at the end of a swipe */
      this.addEventListener(
        'click',
        (e) => {
          if (this.dragEndedAt && performance.now() - this.dragEndedAt < 500) {
            e.preventDefault();
            e.stopPropagation();
            this.dragEndedAt = 0;
          }
        },
        true
      );
    }

    /* ---- autoplay: runs only while visible and not hovered / focused / dragged ---- */
    bindAutoplay() {
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (this.dataset.autoplay !== 'true' || reduced || window.Shopify?.designMode) return;
      this.interval = Math.max(2000, Number(this.dataset.interval || 3) * 1000);
      this.autoplay = true;

      this.addEventListener('pointerenter', (e) => e.pointerType === 'mouse' && this.hold('hover'));
      this.addEventListener('pointerleave', (e) => e.pointerType === 'mouse' && this.release('hover'));
      /* keyboard focus only: a mouse drag that starts on a link also focuses it and must not park the slider */
      this.addEventListener('focusin', (e) => e.target.matches(':focus-visible') && this.hold('focus'));
      this.addEventListener('focusout', (e) => !this.contains(e.relatedTarget) && this.release('focus'));

      this.onVisibility = () => (document.hidden ? this.hold('hidden') : this.release('hidden'));
      document.addEventListener('visibilitychange', this.onVisibility);

      if ('IntersectionObserver' in window) {
        this.hold('offscreen');
        this.observer = new IntersectionObserver(
          (entries) => (entries.some((en) => en.isIntersecting) ? this.release('offscreen') : this.hold('offscreen')),
          { threshold: 0.4 }
        );
        this.observer.observe(this);
      } else {
        this.startAutoplay();
      }
    }

    hold(reason) {
      this.holds.add(reason);
      this.stopAutoplay();
    }

    release(reason) {
      this.holds.delete(reason);
      if (!this.holds.size) this.startAutoplay();
    }

    startAutoplay() {
      if (!this.autoplay || this.timer || this.holds.size) return;
      this.timer = setInterval(() => this.go(this.index + 1), this.interval);
    }

    stopAutoplay() {
      clearInterval(this.timer);
      this.timer = null;
    }

    activateConcern(index) {
      this.querySelectorAll('.ohoh-concern-row').forEach((row) =>
        row.classList.toggle('is-active', row.dataset.index === index)
      );
      this.querySelectorAll('.ohoh-concern-pane').forEach((pane) =>
        pane.classList.toggle('is-active', pane.dataset.index === index)
      );
    }
  }
  if (!customElements.get('ohoh-hero')) customElements.define('ohoh-hero', OhohHero);

  /* ---- campaign slider ---- */
  class OhohCampaign extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('.ohoh-campaign__slide'));
      this.buttons = Array.from(this.querySelectorAll('.ohoh-campaign__rail button'));
      this.buttons.forEach((btn, i) => btn.addEventListener('click', () => this.go(i)));
    }

    go(i) {
      this.slides.forEach((slide, s) => slide.classList.toggle('is-active', s === i));
      this.buttons.forEach((btn, b) => btn.setAttribute('aria-current', b === i ? 'true' : 'false'));
    }
  }
  if (!customElements.get('ohoh-campaign')) customElements.define('ohoh-campaign', OhohCampaign);

  /* ---- header: mobile drawer ---- */
  class OhohHeader extends HTMLElement {
    connectedCallback() {
      const burger = this.querySelector('.ohoh-header__burger');
      const drawer = this.querySelector('.ohoh-header__drawer');
      if (burger && drawer) {
        burger.addEventListener('click', () => {
          const open = drawer.classList.toggle('is-open');
          burger.setAttribute('aria-expanded', open ? 'true' : 'false');
        });
      }

      /* desktop search: icon toggles a drop-down box */
      const toggle = this.querySelector('.ohoh-header__search-toggle');
      const form = this.querySelector('.ohoh-header__search--inline');
      if (toggle && form) {
        const input = form.querySelector('input[type="search"]');
        const setOpen = (open) => {
          form.hidden = !open;
          toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
          if (open && input) input.focus();
        };
        toggle.addEventListener('click', () => setOpen(form.hidden));
        document.addEventListener('click', (e) => {
          if (!form.hidden && !toggle.contains(e.target) && !form.contains(e.target)) setOpen(false);
        });
        this.addEventListener('keydown', (e) => {
          if (e.key === 'Escape' && !form.hidden) {
            setOpen(false);
            toggle.focus();
          }
        });
      }
    }
  }
  if (!customElements.get('ohoh-header')) customElements.define('ohoh-header', OhohHeader);

  /* ---- reviews carousel ---- */
  class OhohReviews extends HTMLElement {
    connectedCallback() {
      this.carousel = this.querySelector('.ohoh-reviews__carousel');
      this.track = this.querySelector('.ohoh-reviews__track');
      this.cards = Array.from(this.querySelectorAll('.ohoh-review-card'));
      this.dotsWrap = this.querySelector('.ohoh-reviews__dots');
      if (!this.track || !this.cards.length) return;

      this.querySelector('.ohoh-reviews__arrow--prev')?.addEventListener('click', () => this.move(-1));
      this.querySelector('.ohoh-reviews__arrow--next')?.addEventListener('click', () => this.move(1));

      this.dots = this.cards.map((_, i) => {
        const b = document.createElement('button');
        b.type = 'button';
        b.setAttribute('role', 'tab');
        b.setAttribute('aria-label', `${i + 1} / ${this.cards.length}`);
        b.addEventListener('click', () => this.goTo(i));
        this.dotsWrap?.appendChild(b);
        return b;
      });

      let raf = null;
      this.track.addEventListener('scroll', () => {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(() => this.sync());
      });
      window.addEventListener('resize', () => this.sync());
      this.sync();

      /* autoplay: pauses while hovered, focused or touched */
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (this.dataset.autoplay === 'true' && !reduced) {
        const every = Math.max(2000, Number(this.dataset.interval || 5) * 1000);
        const start = () => {
          if (this.timer) return;
          this.timer = setInterval(() => this.move(1), every);
        };
        const stop = () => {
          clearInterval(this.timer);
          this.timer = null;
        };
        ['mouseenter', 'focusin', 'touchstart'].forEach((evt) => this.addEventListener(evt, stop, { passive: true }));
        ['mouseleave', 'focusout'].forEach((evt) => this.addEventListener(evt, start));
        if ('IntersectionObserver' in window) {
          new IntersectionObserver((entries) => (entries.some((e) => e.isIntersecting) ? start() : stop()), {
            threshold: 0.4,
          }).observe(this);
        } else {
          start();
        }
      }
    }

    step() {
      const first = this.cards[0];
      const gap = parseFloat(getComputedStyle(this.track).columnGap || getComputedStyle(this.track).gap) || 0;
      return first.offsetWidth + gap;
    }

    current() {
      return Math.round(this.track.scrollLeft / this.step());
    }

    maxIndex() {
      return Math.max(0, Math.round((this.track.scrollWidth - this.track.clientWidth) / this.step()));
    }

    goTo(i) {
      const max = this.maxIndex();
      const target = i < 0 ? max : i > max ? 0 : i;
      this.track.scrollTo({ left: target * this.step(), behavior: 'smooth' });
    }

    move(dir) {
      this.goTo(this.current() + dir);
    }

    sync() {
      const scrollable = this.track.scrollWidth > this.track.clientWidth + 2;
      this.carousel?.classList.toggle('is-static', !scrollable);
      const max = this.maxIndex();
      const cur = Math.min(this.current(), max);
      this.dots.forEach((dot, i) => {
        dot.hidden = i > max;
        dot.setAttribute('aria-current', i === cur ? 'true' : 'false');
      });
      this.markCenter();
    }

    /* R3-5: the card whose middle is nearest the middle of the viewport gets raised */
    markCenter() {
      const mid = this.track.scrollLeft + this.track.clientWidth / 2;
      let best = null;
      let bestDist = Infinity;
      this.cards.forEach((card) => {
        const dist = Math.abs(card.offsetLeft + card.offsetWidth / 2 - mid);
        if (dist < bestDist) {
          bestDist = dist;
          best = card;
        }
      });
      this.cards.forEach((card) => card.classList.toggle('is-center', card === best));
    }
  }
  if (!customElements.get('ohoh-reviews')) customElements.define('ohoh-reviews', OhohReviews);

  /* ---- ohoh-snap: dots for a native scroll-snap track (Top Picks on phones).
     Does nothing while the track is not scrollable, i.e. on tablet / desktop
     where the same markup is a plain grid. ---- */
  class OhohSnap extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-ohoh-snap-track]');
      this.dotsWrap = this.querySelector('[data-ohoh-snap-dots]');
      this.items = this.track ? Array.from(this.track.children) : [];
      if (!this.track || !this.dotsWrap || this.items.length < 2) return;
      this.dots = [];
      let raf = null;
      this.track.addEventListener(
        'scroll',
        () => {
          cancelAnimationFrame(raf);
          raf = requestAnimationFrame(() => this.sync());
        },
        { passive: true }
      );
      window.addEventListener('resize', () => this.sync());
      this.querySelector('[data-ohoh-snap-prev]')?.addEventListener('click', () => this.goTo(this.current() - 1));
      this.querySelector('[data-ohoh-snap-next]')?.addEventListener('click', () => this.goTo(this.current() + 1));
      this.sync();
    }

    step() {
      const s = getComputedStyle(this.track);
      const gap = parseFloat(s.columnGap || s.gap) || 0;
      return this.items[0].getBoundingClientRect().width + gap;
    }

    maxIndex() {
      return Math.max(0, Math.round((this.track.scrollWidth - this.track.clientWidth) / this.step()));
    }

    current() {
      return Math.min(this.maxIndex(), Math.round(this.track.scrollLeft / this.step()));
    }

    goTo(i) {
      this.track.scrollTo({ left: Math.max(0, Math.min(this.maxIndex(), i)) * this.step(), behavior: 'smooth' });
    }

    sync() {
      const scrollable = this.track.scrollWidth > this.track.clientWidth + 2;
      this.classList.toggle('is-static', !scrollable);
      const n = scrollable ? this.maxIndex() + 1 : 0;
      while (this.dots.length < n) {
        const b = document.createElement('button');
        const i = this.dots.length;
        b.type = 'button';
        b.setAttribute('role', 'tab');
        b.setAttribute('aria-label', `${i + 1} / ${this.items.length}`);
        b.addEventListener('click', () => this.goTo(i));
        this.dotsWrap.appendChild(b);
        this.dots.push(b);
      }
      const cur = this.current();
      this.dots.forEach((dot, i) => {
        dot.hidden = i >= n;
        dot.setAttribute('aria-current', i === cur ? 'true' : 'false');
      });
    }
  }
  if (!customElements.get('ohoh-snap')) customElements.define('ohoh-snap', OhohSnap);

  /* ---- ohoh-stack: one card at a time on phones, the next card slides in
     from the top (blog). Arrows, dots and a horizontal swipe move it; above
     749px the cards are left alone and stay a grid. ---- */
  class OhohStack extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-ohoh-stack-track]');
      this.cards = this.track ? Array.from(this.track.children) : [];
      this.dotsWrap = this.querySelector('[data-ohoh-stack-dots]');
      if (!this.track || this.cards.length < 2) return;
      this.index = 0;

      this.dots = this.cards.map((_, i) => {
        const b = document.createElement('button');
        b.type = 'button';
        b.setAttribute('role', 'tab');
        b.setAttribute('aria-label', `${i + 1} / ${this.cards.length}`);
        b.addEventListener('click', () => this.go(i));
        this.dotsWrap?.appendChild(b);
        return b;
      });
      this.querySelector('[data-ohoh-stack-prev]')?.addEventListener('click', () => this.go(this.index - 1));
      this.querySelector('[data-ohoh-stack-next]')?.addEventListener('click', () => this.go(this.index + 1));

      this.mq = window.matchMedia('(max-width: 749px)');
      this.mq.addEventListener('change', () => this.apply());
      this.apply();
      this.bindSwipe();
    }

    apply() {
      const stacked = this.mq.matches;
      this.classList.toggle('is-stacked', stacked);
      if (stacked) {
        this.go(this.index, true);
      } else {
        this.cards.forEach((card) => {
          card.classList.remove('is-active', 'is-leaving');
          card.inert = false;
        });
      }
    }

    go(i, instant) {
      const n = this.cards.length;
      const next = ((i % n) + n) % n;
      const leaving = this.cards[this.index];
      this.cards.forEach((card) => {
        if (card === leaving && card !== this.cards[next] && !instant) return;
        /* park the card above its slot without animating, so it always enters from the top */
        card.style.transition = 'none';
        card.classList.remove('is-active', 'is-leaving');
        void card.offsetWidth;
        card.style.transition = '';
      });
      if (leaving !== this.cards[next] && !instant) {
        leaving.classList.remove('is-active');
        leaving.classList.add('is-leaving');
      }
      this.cards[next].classList.add('is-active');
      this.cards.forEach((card, c) => (card.inert = c !== next));
      this.index = next;
      this.dots.forEach((dot, d) => dot.setAttribute('aria-current', d === next ? 'true' : 'false'));
    }

    /* horizontal swipe on the card moves it; vertical movement keeps scrolling
       the page. Touch events are used for fingers (a pan never cancels them),
       pointer events cover a mouse drag. */
    bindSwipe() {
      let startX = 0;
      let startY = 0;
      const begin = (x, y) => {
        startX = x;
        startY = y;
      };
      const finish = (x, y) => {
        if (!this.mq.matches) return;
        const dx = x - startX;
        const dy = y - startY;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) this.go(this.index - Math.sign(dx));
      };
      this.track.addEventListener('touchstart', (e) => begin(e.touches[0].clientX, e.touches[0].clientY), { passive: true });
      this.track.addEventListener('touchend', (e) => finish(e.changedTouches[0].clientX, e.changedTouches[0].clientY));
      this.track.addEventListener('pointerdown', (e) => e.pointerType === 'mouse' && begin(e.clientX, e.clientY));
      this.track.addEventListener('pointerup', (e) => e.pointerType === 'mouse' && finish(e.clientX, e.clientY));
      this.track.addEventListener('dragstart', (e) => this.mq.matches && e.preventDefault());
    }
  }
  if (!customElements.get('ohoh-stack')) customElements.define('ohoh-stack', OhohStack);

  /* ---- ohoh-blog-pages: on phones the blog listing shows a few articles at a
     time (data-phone-size, default 3) with a pagination control under them.
     The server still paginates by "Articles per page"; the phone pages split
     each server page, and page numbers that fall on another server page link
     there with a #p<n> hash picking the slice. Above 749px nothing changes. ---- */
  class OhohBlogPages extends HTMLElement {
    connectedCallback() {
      this.grid = this.querySelector('.ohoh-blog-listing__grid');
      this.cards = this.grid ? Array.from(this.grid.children) : [];
      this.nav = this.querySelector('[data-ohoh-pages-phone]');
      this.serverNav = this.querySelector('[data-ohoh-pages-server]');
      if (!this.grid || !this.nav) return;
      const d = this.dataset;
      this.page = Math.max(1, parseInt(d.page, 10) || 1);
      this.pages = Math.max(this.page, parseInt(d.pages, 10) || 1);
      this.size = Math.max(1, parseInt(d.pageSize, 10) || this.cards.length || 1);
      this.items = parseInt(d.items, 10) || this.cards.length;
      this.per = Math.max(1, parseInt(d.phoneSize, 10) || 3);
      const featured = d.featured === '1';

      /* phone pages on each server page: [{ first, count }] */
      this.subs = [];
      let total = 0;
      for (let p = 1; p <= this.pages; p++) {
        let cards = Math.min(this.size, this.items - (p - 1) * this.size);
        if (p === 1 && featured) cards -= 1;
        if (p === this.page) cards = this.cards.length;
        const count = Math.max(1, Math.ceil(cards / this.per));
        this.subs.push({ first: total + 1, count });
        total += count;
      }
      this.total = total;
      this.sub = this.subFromHash();

      this.mq = window.matchMedia('(max-width: 749px)');
      this.mq.addEventListener('change', () => this.apply());
      window.addEventListener('hashchange', () => {
        this.sub = this.subFromHash();
        this.apply();
      });
      this.apply();
      if (this.mq.matches && /^#p\d+$/.test(location.hash)) this.scrollToGrid('auto');
    }

    subFromHash() {
      const m = location.hash.match(/^#p(\d+)$/);
      const n = m ? parseInt(m[1], 10) : 1;
      return Math.min(Math.max(1, n), this.subs[this.page - 1].count);
    }

    apply() {
      if (!this.mq.matches) {
        this.cards.forEach((card) => (card.hidden = false));
        this.nav.hidden = true;
        if (this.serverNav) this.serverNav.hidden = false;
        return;
      }
      const start = (this.sub - 1) * this.per;
      this.cards.forEach((card, i) => (card.hidden = i < start || i >= start + this.per));
      if (this.serverNav) this.serverNav.hidden = true;
      this.renderNav();
    }

    /* phone page number -> server page, slice and URL */
    target(v) {
      const p = this.subs.findIndex((s) => v >= s.first && v < s.first + s.count) + 1;
      const sub = v - this.subs[p - 1].first + 1;
      const url = new URL(location.href);
      if (p === 1) url.searchParams.delete('page');
      else url.searchParams.set('page', p);
      url.hash = sub > 1 ? `p${sub}` : '';
      return { p, sub, href: url.href };
    }

    renderNav() {
      const cur = this.subs[this.page - 1].first + this.sub - 1;
      this.nav.innerHTML = '';
      this.nav.hidden = this.total < 2;
      if (this.total < 2) return;
      const link = (label, v, ariaLabel) => {
        const t = this.target(v);
        const a = document.createElement('a');
        a.href = t.href;
        a.textContent = label;
        if (ariaLabel) a.setAttribute('aria-label', ariaLabel);
        a.addEventListener('click', (e) => {
          if (t.p !== this.page) return; /* another server page: follow the link */
          e.preventDefault();
          this.sub = t.sub;
          history.replaceState(null, '', t.href);
          this.apply();
          this.scrollToGrid('smooth');
        });
        return a;
      };
      const gap = () => {
        const s = document.createElement('span');
        s.className = 'ohoh-pagination__gap';
        s.textContent = '…';
        return s;
      };
      if (cur > 1) this.nav.appendChild(link('‹', cur - 1, 'Previous page'));
      let last = 0;
      for (let v = 1; v <= this.total; v++) {
        const show = this.total <= 5 || v === 1 || v === this.total || Math.abs(v - cur) <= 1;
        if (!show) continue;
        if (v - last > 1) this.nav.appendChild(gap());
        if (v === cur) {
          const s = document.createElement('span');
          s.className = 'is-current';
          s.setAttribute('aria-current', 'page');
          s.textContent = v;
          this.nav.appendChild(s);
        } else {
          this.nav.appendChild(link(String(v), v));
        }
        last = v;
      }
      if (cur < this.total) this.nav.appendChild(link('›', cur + 1, 'Next page'));
    }

    scrollToGrid(behavior) {
      const top = this.grid.getBoundingClientRect().top + window.scrollY - 150;
      window.scrollTo({ top: Math.max(0, top), behavior });
    }
  }
  if (!customElements.get('ohoh-blog-pages')) customElements.define('ohoh-blog-pages', OhohBlogPages);

  /* ---- read more: shows the toggle only when the clamped paragraph actually overflows ---- */
  class OhohReadmore extends HTMLElement {
    connectedCallback() {
      this.text = this.querySelector('p');
      this.btn = this.querySelector('.ohoh-readmore__toggle');
      if (!this.text || !this.btn) return;
      this.btn.addEventListener('click', () => this.toggle());
      this.measure = () => {
        if (this.classList.contains('is-expanded')) return;
        this.classList.toggle('has-overflow', this.text.scrollHeight > this.text.clientHeight + 1);
      };
      window.addEventListener('resize', this.measure);
      this.measure();
      document.fonts?.ready.then(this.measure);
    }

    disconnectedCallback() {
      if (this.measure) window.removeEventListener('resize', this.measure);
    }

    toggle() {
      const open = this.classList.toggle('is-expanded');
      this.btn.setAttribute('aria-expanded', String(open));
      this.btn.textContent = open ? this.btn.dataset.less : this.btn.dataset.more;
    }
  }
  if (!customElements.get('ohoh-readmore')) customElements.define('ohoh-readmore', OhohReadmore);

  /* ---- skin quiz ---- */
  class OhohQuiz extends HTMLElement {
    connectedCallback() {
      this.modal = this.querySelector('.ohoh-quiz');
      this.questions = Array.from(this.querySelectorAll('[data-quiz-question]'));
      this.results = Array.from(this.querySelectorAll('[data-quiz-result]'));
      this.step = 0;
      this.keyAnswer = null;

      document.querySelectorAll('[data-ohoh-quiz-open]').forEach((btn) => {
        btn.addEventListener('click', () => this.open());
      });
      this.querySelectorAll('[data-quiz-close]').forEach((el) => el.addEventListener('click', () => this.close()));
      this.addEventListener('keyup', (e) => e.code === 'Escape' && this.close());

      this.questions.forEach((q) => {
        q.querySelectorAll('.ohoh-quiz__options button').forEach((btn) => {
          btn.addEventListener('click', () => this.answer(q, Number(btn.dataset.option)));
        });
      });

      this.querySelectorAll('[data-quiz-add-all]').forEach((btn) => {
        btn.addEventListener('click', () => {
          const ids = (btn.dataset.quizAddAll || '')
            .split(',')
            .map((v) => Number(v))
            .filter(Boolean);
          if (!ids.length) return;
          this.close();
          ohohAddToCart(
            ids.map((id) => ({ id, quantity: 1 })),
            btn.dataset.message || ''
          );
        });
      });
    }

    open() {
      this.step = 0;
      this.keyAnswer = null;
      this.modal.hidden = false;
      this.render();
      this.querySelector('.ohoh-quiz__panel')?.focus();
    }

    close() {
      this.modal.hidden = true;
    }

    answer(questionEl, option) {
      if (questionEl.dataset.quizKey === 'true') this.keyAnswer = option;
      this.step += 1;
      this.render();
    }

    render() {
      const done = this.step >= this.questions.length;
      this.questions.forEach((q, i) => (q.hidden = done || i !== this.step));
      if (!done) {
        this.results.forEach((r) => (r.hidden = true));
        return;
      }
      let match =
        this.results.find((r) => Number(r.dataset.quizResult) === this.keyAnswer + 1) || this.results[this.results.length - 1];
      this.results.forEach((r) => (r.hidden = r !== match));
    }
  }
  if (!customElements.get('ohoh-quiz')) customElements.define('ohoh-quiz', OhohQuiz);

  /* hide quiz buttons when no quiz section is on the page */
  document.addEventListener('DOMContentLoaded', () => {
    if (!document.querySelector('ohoh-quiz')) {
      document.querySelectorAll('[data-ohoh-quiz-open]').forEach((btn) => (btn.style.display = 'none'));
    }
  });

  /* ---- brand voice in copy: "oh!oh!" in Libre Bodoni Italic (.ohoh-brand); rich-text tagline/body tags ---- */
  document.addEventListener('DOMContentLoaded', () => {
    const roots = document.querySelectorAll(
      '.rich-text__text, .ohoh-philosophy__body, .ohoh-footer, .ohoh-article__content, .rte, .ohoh-page__content'
    );
    roots.forEach((root) => {
      const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
      const nodes = [];
      let node;
      while ((node = walker.nextNode())) {
        if (node.nodeValue.includes('oh!oh!') && !node.parentElement.closest('script, style, .ohoh-brand, h1, h2, h3')) nodes.push(node);
      }
      nodes.forEach((text) => {
        const frag = document.createDocumentFragment();
        text.nodeValue.split(/(oh!oh!)/).forEach((part) => {
          if (part === 'oh!oh!') {
            const span = document.createElement('span');
            span.className = 'ohoh-brand';
            span.textContent = part;
            frag.appendChild(span);
          } else if (part) {
            frag.appendChild(document.createTextNode(part));
          }
        });
        text.parentNode.replaceChild(frag, text);
      });
    });
    document.querySelectorAll('.rich-text__text').forEach((rte) => {
      const paragraphs = [...rte.querySelectorAll(':scope > p')];
      paragraphs.forEach((p) => {
        const em = p.querySelector(':scope > em');
        if (em && p.textContent.trim() === em.textContent.trim()) p.classList.add('ohoh-rte-tagline');
      });
      const body = paragraphs.filter((p) => !p.classList.contains('ohoh-rte-tagline'));
      if (body.length && body.length < paragraphs.length) {
        body[0].classList.add('ohoh-rte-body--first');
        body[body.length - 1].classList.add('ohoh-rte-body--last');
      }
    });
  });

  /* ---- filter selects that navigate (collection page) ---- */
  document.addEventListener('change', (event) => {
    const select = event.target.closest('select[data-ohoh-nav-select]');
    if (select && select.value) window.location.href = select.value;
  });

  /* ---- quantity steppers ---- */
  document.addEventListener('click', (event) => {
    const btn = event.target.closest('[data-ohoh-qty-change]');
    if (!btn) return;
    const input = btn.closest('.ohoh-qty')?.querySelector('input');
    if (!input) return;
    const next = Math.max(1, (parseInt(input.value, 10) || 1) + Number(btn.dataset.ohohQtyChange));
    input.value = next;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---- product page ---- */
  class OhohProduct extends HTMLElement {
    connectedCallback() {
      /* gallery slider */
      const track = this.querySelector('[data-ohoh-gallery-track]');
      if (track) {
        const slides = Array.from(track.querySelectorAll('[data-ohoh-gallery-slide]'));
        const prev = this.querySelector('[data-ohoh-gallery-prev]');
        const next = this.querySelector('[data-ohoh-gallery-next]');
        const counter = this.querySelector('[data-ohoh-gallery-counter]');
        let index = 0;

        const sync = () => {
          if (counter) counter.textContent = `${index + 1}/${slides.length}`;
          if (prev) prev.disabled = index === 0;
          if (next) next.disabled = index === slides.length - 1;
        };

        const goTo = (i) => {
          index = Math.max(0, Math.min(slides.length - 1, i));
          const target = slides[index];
          if (target) track.scrollLeft = target.offsetLeft - slides[0].offsetLeft;
          sync();
        };

        prev?.addEventListener('click', () => goTo(index - 1));
        next?.addEventListener('click', () => goTo(index + 1));
        this.goToSlide = goTo;
        this.slides = slides;

        /* keep state in step with swipes and trackpad scrolling */
        let scrollTimer;
        track.addEventListener(
          'scroll',
          () => {
            clearTimeout(scrollTimer);
            scrollTimer = setTimeout(() => {
              const width = slides[0]?.getBoundingClientRect().width || track.clientWidth;
              const nearest = width ? Math.round(track.scrollLeft / width) : 0;
              if (nearest !== index) {
                index = Math.max(0, Math.min(slides.length - 1, nearest));
                sync();
              }
            }, 80);
          },
          { passive: true }
        );

        track.addEventListener('keydown', (event) => {
          if (event.key === 'ArrowRight') {
            event.preventDefault();
            goTo(index + 1);
          } else if (event.key === 'ArrowLeft') {
            event.preventDefault();
            goTo(index - 1);
          }
        });

        sync();
      }

      /* qty → ATC label + buttons */
      this.qtyInput = this.querySelector('.ohoh-qty input');
      this.price = Number(this.dataset.price || 0);
      this.atcButtons = Array.from(this.querySelectorAll('[data-ohoh-add]'));
      const syncQty = () => {
        const qty = Math.max(1, parseInt(this.qtyInput?.value, 10) || 1);
        this.atcButtons.forEach((btn) => {
          btn.dataset.ohohAddQty = qty;
          const label = btn.querySelector('[data-atc-total]');
          if (label && this.price && window.theme?.moneyFormat) {
            label.textContent = formatMoney(this.price * qty, window.theme.moneyFormat);
          }
        });
      };
      this.qtyInput?.addEventListener('change', syncQty);
      syncQty();

      /* R5-1: variant (volume) picker */
      const optionsWrap = this.querySelector('[data-ohoh-options]');
      const variantData = this.querySelector('[data-ohoh-variants]');
      if (optionsWrap && variantData) {
        let variants = [];
        try {
          variants = JSON.parse(variantData.textContent);
        } catch (e) {
          variants = [];
        }
        const inputs = Array.from(optionsWrap.querySelectorAll('input[type="radio"]'));
        const optionCount = inputs.reduce((max, input) => Math.max(max, Number(input.dataset.ohohOption) + 1), 0);

        const selectedOptions = () => {
          const values = new Array(optionCount).fill(null);
          inputs.forEach((input) => {
            if (input.checked) values[Number(input.dataset.ohohOption)] = input.value;
          });
          return values;
        };

        const findVariant = (values) =>
          variants.find((v) => v.options.every((option, i) => option === values[i]));

        /* strike through values that would give a sold-out (or non-existent) combination */
        const markAvailability = (values) => {
          inputs.forEach((input) => {
            const i = Number(input.dataset.ohohOption);
            const probe = values.slice();
            probe[i] = input.value;
            const match = findVariant(probe);
            input.closest('.ohoh-product__option-value')?.classList.toggle('is-unavailable', !match || !match.available);
          });
        };

        const applyVariant = (variant) => {
          this.price = variant.price;
          this.querySelectorAll('[data-ohoh-price]').forEach((el) => {
            el.textContent = variant.price_formatted;
          });
          const compare = this.querySelector('[data-ohoh-compare]');
          if (compare) {
            compare.textContent = variant.compare_formatted || '';
            compare.hidden = !variant.compare_formatted;
          }
          this.atcButtons.forEach((btn) => {
            btn.dataset.ohohAdd = variant.id;
            btn.disabled = !variant.available;
            const label = btn.querySelector('[data-atc-label]');
            if (label) label.textContent = variant.available ? btn.dataset.labelAdd : btn.dataset.labelOos;
            const total = btn.querySelector('.ohoh-product__atc-total');
            if (total) total.hidden = !variant.available;
          });
          this.querySelectorAll('[data-ohoh-buy-now]').forEach((btn) => {
            btn.dataset.ohohBuyNow = variant.id;
            btn.disabled = !variant.available;
          });
          syncQty();

          if (variant.media_id && this.goToSlide && this.slides) {
            const slideIndex = this.slides.findIndex((slide) => Number(slide.dataset.mediaId) === variant.media_id);
            if (slideIndex >= 0) this.goToSlide(slideIndex);
          }

          const url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          window.history.replaceState({}, '', url.toString());
        };

        optionsWrap.addEventListener('change', () => {
          const values = selectedOptions();
          const variant = findVariant(values);
          markAvailability(values);
          if (variant) applyVariant(variant);
        });
        markAvailability(selectedOptions());
      }

      /* buy now */
      this.querySelectorAll('[data-ohoh-buy-now]').forEach((btn) => {
        btn.addEventListener('click', () => {
          const qty = Math.max(1, parseInt(this.qtyInput?.value, 10) || 1);
          window.location.href = `/cart/${btn.dataset.ohohBuyNow}:${qty}?payment=express`;
        });
      });

      /* sticky bar */
      this.stickyBar = this.querySelector('.ohoh-sticky-atc');
      if (this.stickyBar) {
        this.onScroll = () => {
          this.stickyBar.classList.toggle('is-visible', window.scrollY > 620);
        };
        window.addEventListener('scroll', this.onScroll, { passive: true });
        this.onScroll();
      }
    }

    disconnectedCallback() {
      if (this.onScroll) window.removeEventListener('scroll', this.onScroll);
    }
  }
  if (!customElements.get('ohoh-product')) customElements.define('ohoh-product', OhohProduct);

  function formatMoney(cents, format) {
    const value = (cents / 100).toFixed(0);
    const withDelims = value.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return format
      .replace(/\{\{\s*amount[^}]*\}\}/, withDelims)
      .replace(/<[^>]+>/g, '')
      .trim();
  }

  /* ---- product tabs ---- */
  class OhohTabs extends HTMLElement {
    connectedCallback() {
      const buttons = Array.from(this.querySelectorAll('.ohoh-ptabs__nav button'));
      const panels = Array.from(this.querySelectorAll('.ohoh-ptabs__panel'));
      buttons.forEach((btn, i) =>
        btn.addEventListener('click', () => {
          buttons.forEach((b, j) => b.setAttribute('aria-current', i === j ? 'true' : 'false'));
          panels.forEach((p, j) => p.classList.toggle('is-active', i === j));
        })
      );
    }
  }
  if (!customElements.get('ohoh-tabs')) customElements.define('ohoh-tabs', OhohTabs);
})();
